import firebaseConfig from "./fcm_config";
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const fetchToken = () => {
    return getToken(messaging, { vapidKey: 'BDRXMPPnKRpF4uvvMSbpVNE09cxIlHCPg7IkY5-GdyGbApwBPuvJh0oB4pqPtfTeQkBy-myL1cem7-UC7zmd6qY' });
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
});

export const fcmIsSupported = () => {
    return isSupported();
};